// eslint-disable-next-line import/prefer-default-export
export const title = 'Gift Cards';
